module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("t99t9"))).then(() => parcelRequire('co2TE'));